<template>
  <div class="tusmo-logo-wrap">
    <div class="tusmo-logo-inner">
      <div class="tusmo-letter tusmo-letter-red tusmo-letter-t">T</div>
      <div class="tusmo-letter tusmo-letter-u">U</div>
      <div class="tusmo-letter tusmo-letter-yellow tusmo-letter-s">S</div>
      <div class="tusmo-letter tusmo-letter-m">M</div>
      <div class="tusmo-letter tusmo-letter-red tusmo-letter-o">O</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TusmoLogo",
};
</script>

<style scoped>
.tusmo-logo-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 300px;
  height: 64px;
  box-sizing: border-box;
}

/* conteneur interne qui positionne les lettres */
.tusmo-logo-inner {
  position: relative;
  width: 252px;
  height: 64px;
  display: block;
  box-sizing: border-box;
  font-size: 60px;
  line-height: 1;
}

/* base commune à chaque lettre */
.tusmo-letter {
  position: absolute;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 4px;
  box-sizing: border-box;
  color: #ffffff;
  font-weight: 600;
}

/* T et O : blocs rouges avec ombre et coins légèrement arrondis */
.tusmo-letter-red {
  background-color: rgb(219, 58, 52);
  border-radius: 4px;
  box-shadow: rgb(50, 48, 49) 0 8px 0 0;
}

/* S : rond jaune avec ombre */
.tusmo-letter-yellow {
  background-color: rgb(247, 183, 53);
  border-radius: 9999px;
  box-shadow: rgb(50, 48, 49) 0 8px 0 0;
}

/* positions horizontales (reprises du HTML d'origine) */
.tusmo-letter-t {
  left: 0;
  z-index: 0;
}

.tusmo-letter-u {
  left: 44.8px;
  z-index: 1;
  background: transparent;
  box-shadow: none;
}

.tusmo-letter-s {
  left: 88px;
  z-index: 0;
}

.tusmo-letter-m {
  left: 136px;
  z-index: 1;
  background: transparent;
  box-shadow: none;
}

.tusmo-letter-o {
  left: 188.8px;
  z-index: 0;
}

/* petit ajustement responsive si tu l’utilises sur mobile */
@media (max-width: 400px) {
  .tusmo-logo-wrap {
    transform: scale(0.8);
    transform-origin: top center;
  }
}
</style>
